<div *ngFor="let layer of layers$ | async"
     [style.top.px]="layer.position.top"
     [style.left.px]="layer.position.left"
     [style.right.px]="layer.position.right"
     [style.bottom.px]="layer.position.bottom"
>
  <ng-container *ngTemplateOutlet="layer.view"></ng-container>
</div>
